import * as React from 'react';
import classnames from 'classnames';

const BrandListItem = ({ url , children , className  })=>/*#__PURE__*/ React.createElement("a", {
        className: classnames('brand-list-item', className),
        href: url
    }, children)
;
var BrandListItem$1 = /*#__PURE__*/ React.memo(BrandListItem);

export { BrandListItem$1 as default };
//# sourceMappingURL=BrandListItem.js.map
